<template>
    <div class="modal duration-0 fixed inset-0 bg-blacker bg-opacity-70 bg-blurry hidden" tabindex="-1" ref="modalRef">
      <div class="flex items-center justify-center h-full">
        <div class="modal-dialog bg-dark rounded-lg inline-block shadow-wide shadow-lg max-w-md w-full md:w-1/2 xl:w-1/4">
          <div class="modal-content">
            <div class="modal-header border-b border-grey border-opacity-25 px-6 py-4 flex justify-between items-center">
              <h5 class="modal-title text-lg font-semibold">{{ title }}</h5>
              <button type="button" class="close" @click="hide">
                &times;
              </button>
            </div>
            <div class="modal-body px-6 py-4">
              <slot name="body"></slot>
            </div>
            <div class="modal-footer flex justify-end px-4 mb-4 mt-2">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import { Modal } from 'bootstrap';
  
  export default {
    name: 'Modal',
    props: {
      title: {
        type: String,
        default: '',
      },
    },
    setup(props, { expose }) {
      const modalRef = ref(null);
      let bsModal = null;
  
      const show = () => {
        bsModal.show();
      };
  
      const hide = () => {
        bsModal.hide();
      };
  
      onMounted(() => {
        bsModal = new Modal(modalRef.value, {
          backdrop: 'static',
          keyboard: false,
        });
      });
  
      onBeforeUnmount(() => {
        if (bsModal) {
          bsModal.dispose();
        }
      });
  
      // Expose the show and hide methods to the parent component
      expose({
        show,
        hide,
      });
  
      return {
        modalRef,
        show,
        hide,
      };
    },
  };
  </script>
  
  <style scoped>
  /* Add any custom styles if necessary */
  </style>
